<template>
  <div class="notification-container">
    <NotificationBar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </div>
</template>

<script>
import NotificationBar from '@/components/NotificationBar.vue'
import { mapState } from 'vuex'

export default {
  components: {
    NotificationBar
  },
  computed: mapState('notification', ['notifications'])
}
</script>

<style scoped>
/* Sizing and position mirror the app-standard `.notification-cnt` toast block
   (src/assets/scss/_custom.scss) so store-driven toasts look identical to the
   per-screen v-alert toasts they appear alongside: width hugs the message, capped
   at 500px. `width: 100%` here used to stretch every toast to the container width,
   which made short messages (e.g. "Formula saved") far wider than the rest. */
.notification-container {
  position: fixed;
  bottom: 0;
  right: 10%;
  width: auto;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: none;
  z-index: 9999999999;
}
.notification-container > * {
  max-width: 100%;
  pointer-events: auto;
  /* Keeps long messages wrapping inside the max-width cap instead of overflowing. */
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
